import CtrlProvedoresMultaPage from './pages/CtrlProvedoresMultaPage.vue'
import CtrlProvedorDadosPage from './pages/CtrlProvedorDadosPage.vue'

const routes = [
  {
    path: 'ctrl-provedores-multa',
    name: 'ctrl-provedores-multa',
    component: CtrlProvedoresMultaPage
  },
  {
    path: 'ctrl-provedor-multa/:ctrl_provedor_id',
    name: 'ctrl-provedor-multa',
    component: CtrlProvedorDadosPage
  },
];

export default routes;
